<template>
	<div v-bind="c_test_attrs">
		<label class="font-normal">
			<template v-if="c_ctrlParams.alwaysHook && 0">
				<input type="checkbox" checked onclick="return false;" :title="c_chboxTitle" /> <!-- если рассылка идёт всегда, то ридонли чекбокс который даже не прибиндили к модели -->
			</template>
			<template v-else>
				<input type="checkbox" v-model="c_value" :title="c_chboxTitle" />
			</template>
		</label>
		<div class="ctrl-extraDescr" v-if="c_ctrlParams.extraDescr" v-html="c_ctrlParams.extraDescr"></div>
	</div>
</template>


<script>
	import ctrlMixins from './_mixins.js'
	import { ctrlParamsForAll } from './_common-stuff.ts';

	export default {
		name: 'ctrl_special_editor',
		components: {},
		meta: { // это наши данные, т.е. вуй при объявлении компонента их не использует
			title: 'Хук',
			params: {
				hookList: {
					name: 'Хуки которые инициируются данным контролом',
					editType: 'hookListEd'
				},
				checkedByDefault: {
					name: 'Чекбокс отмечен по умолчанию (но снять можно)',
					editType: 'checkbox'
				},
				alwaysHook: {
					name: 'Хук поджигается всегда',
					tip: 'В пользовательских АРМ как правило этот признак должен быть отмечен. В редакторских АРМ простановка этого признака приводит к тому, что поле скрывается (чтобы не рисовать неактивный и отмеченный по умолчанию чекбокс)',
					editType: 'checkbox'
				},
				hookContentParamColumn: {
					name: 'Колонки, которые попадут в урл формирования хука',
					tip: 'Значения этих колонок попадут в качестве GET-параметров.',
					editType: 'stringList', // временно, потом написать кастомный editType выбора колонок
				},
				...ctrlParamsForAll,
			}
		},
		mixins: [ctrlMixins], // c_value, c_ctrlParams, c_srv_options, пропсы view_type, field_meta и так далее
		props: { // большая часть пропсов приезжает из ctrlMixins!
			value: {
				default: false,
			},
		},
		data: function(){
			return {

			}
		},
		computed: {
			c_chboxTitle: function() {
				var HL = this.c_ctrlParams.hookList;
				if (!HL || HL.length ===0) {
					return '' // 'Контрол не инициирует ни одного хука!';
					// на самом деле пустой hookList говорит только о том,
					// что нет хуков, которые поджигаются и отправляются НЕМЕДЛЕННО
					// контрол может тупо ставить чекбокс, по которому могут отправлять хуки ПО РАСПИСАНИЮ
				}
				else {
					var prefix = this.c_ctrlParams.alwaysHook ? 'Безусловно (всегда) инициирует немедленный запуск хука: ' : 'Инициирует немедленный запуск хуков: ';
					return prefix + HL.map(function(val) {
						return val.name + ' (' + (val.hookTag || val.id) + ')';
					}).join(', ');
				}
			},
		},
		methods: {},
		created: function(){
			if (!this.value && this.$props.field_meta.ctrlParams.checkedByDefault === true) {
				this.c_value = true;
			}
		},
		mounted: function() {},
	}
</script>
